import {
  EXCHANGE_STEP_SELECTION,
  EXCHANGE_SUBMIT_COMPLETE,
  EXCHANGE_SUBMIT_ERROR,
  EXCHANGE_SUBMIT_INITIATE,
  RECEIVE_POST_EXCHANGE_INFO,
  RECEIVE_PRE_EXCHANGE_INFO
} from 'constants/reduxActions';

const initialState = {
  preExchangeInfo: [], // TODO denormalize once we know more about usage
  contractIds: [],
  step: 'SELECT_EXCHANGE_ITEMS',
  postExchangeInfo: [], // TODO denormalize once we know more about usage
  isExchangeSubmitting: false,
  labelInfo: {}, // TODO labels??
  isExchangeError: false
};

export default function exchanges(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PRE_EXCHANGE_INFO :
      return {
        ...state,
        preExchangeInfo: state.preExchangeInfo.concat([action.payload]),
        contractIds: state.contractIds.concat([action.payload.contractId])
      };
    case EXCHANGE_SUBMIT_INITIATE :
      return {
        ...state,
        isExchangeSubmitting: true,
        isExchangeError: false
      };
    case EXCHANGE_SUBMIT_ERROR :
      return {
        ...state,
        isExchangeSubmitting: false,
        isExchangeError: true
      };
    case EXCHANGE_SUBMIT_COMPLETE :
      return {
        ...state,
        isExchangeSubmitting: false,
        isExchangeError: false
      };
    case RECEIVE_POST_EXCHANGE_INFO :
      return {
        ...state,
        postExchangeInfo: state.postExchangeInfo.concat([action.payload])
      };
    case EXCHANGE_STEP_SELECTION :
      return {
        ...state,
        step: action.payload
      };
    default:
      return state;
  }
}
